import { ROUTES } from '#/config/routes';
import {
  rememberAsyncFilterLabels,
  resolveFromLabelCache,
} from '#/modules/commonComponents/table/asyncFilterLabelCache';
import { createAsyncSingleFilterMeta } from '#/modules/commonComponents/table/columnFilterMeta';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { formatSafetyCheckQty } from '#/modules/imsMgmt/inventoryStock/helper/safetyCheckQty';
import { searchWarehouseFilterOptions } from '#/modules/imsMgmt/settings/storePlace/helper/warehouseSelectOptions';

function mtrPathOf(row) {
  return row?.mtr?.id ? ROUTES.mtrDetail(row.mtr.id) : null;
}

/**
 * 安全庫存不足清單欄位。倉別只是查詢範圍（後端依 warehouse_id 只計該倉可用庫存），
 * 不是每列欄位，故掛在「可用量」表頭篩選。
 */
export function buildInventorySafetyCheckColumns({
  filters = {},
  onFilterChange,
  warehouseLabelCache,
}) {
  return [
    {
      id: 'mtrNo',
      header: '料號',
      accessorFn: (row) => row.mtr?.mtrNo ?? '-',
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip
          text={row.original.mtr?.mtrNo ?? '-'}
          detailPath={mtrPathOf(row.original)}
          tooltipContent="雙擊開啟物料（新分頁）"
        />
      ),
    },
    {
      id: 'mtrName',
      header: '名稱',
      accessorFn: (row) => row.mtr?.name ?? '-',
      size: 250,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip
          text={row.original.mtr?.name ?? '-'}
          detailPath={mtrPathOf(row.original)}
          tooltipContent="雙擊開啟物料（新分頁）"
        />
      ),
    },
    {
      id: 'mtrStruct',
      header: '分類',
      accessorFn: (row) => [row.mtr?.mtrStructMain?.name, row.mtr?.mtrStructSub?.name]
        .filter(Boolean)
        .join(' / ') || '-',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'safetyQty',
      header: '安全量',
      accessorFn: (row) => formatSafetyCheckQty(row, 'safetyQty'),
      size: 130,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'warehouseId',
      header: '可用量',
      accessorFn: (row) => formatSafetyCheckQty(row, 'availableQty'),
      size: 130,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_right',
        ...createAsyncSingleFilterMeta({
          key: 'warehouseId',
          label: '計算倉別',
          searchOptions: searchWarehouseFilterOptions,
          filterValue: Array.isArray(filters.warehouseId)
            ? filters.warehouseId[0]
            : filters.warehouseId,
          onChange: (value) => onFilterChange('warehouseId', value),
          resolveFilterDisplay: (values) => (
            resolveFromLabelCache(warehouseLabelCache, values)
          ),
          rememberSelectedOptions: (options, values) => {
            rememberAsyncFilterLabels(warehouseLabelCache, options, values);
          },
        }),
      },
    },
    {
      id: 'shortageQty',
      header: '不足量',
      accessorFn: (row) => formatSafetyCheckQty(row, 'shortageQty'),
      size: 130,
      enableSorting: false,
      meta: { cellClassName: 'td_right font-semibold text-red-600' },
    },
  ];
}
